import { render, staticRenderFns } from "./ConnectionMenu.vue?vue&type=template&id=e4052048&scoped=true&"
import script from "./ConnectionMenu.vue?vue&type=script&lang=js&"
export * from "./ConnectionMenu.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionMenu.vue?vue&type=style&index=0&id=e4052048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4052048",
  null
  
)

export default component.exports